import React from 'react';
import PropTypes from 'prop-types';

const EventMessagesTable = ({ columns, rows, totals, emptyLabel, emptyTitle, emptyIcon, ctaLabel, ctaHref }) => {
  if (!rows || rows.length === 0) {
    return (
      <div className="mi-messages-empty">
        {emptyIcon && <div className="mi-messages-empty-icon">{emptyIcon}</div>}
        {emptyTitle && <p className="mi-messages-empty-title">{emptyTitle}</p>}
        <p className="mi-messages-empty-text">{emptyLabel}</p>
        {ctaLabel && ctaHref && (
          <a className="mi-messages-empty-cta" href={ctaHref}>{ctaLabel}</a>
        )}
      </div>
    );
  }

  return (
    <div className="mi-messages-table-wrap">
      <table className="mi-messages-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.id} style={{ textAlign: col.align || 'left' }}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((col) => (
                <td key={col.id} style={{ textAlign: col.align || 'left' }}>{col.format(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            {columns.map((col, i) => (
              <td key={col.id} style={{ textAlign: col.align || 'left' }}>
                {i === 0 ? 'Totals' : col.totalFormat ? col.totalFormat(totals) : ''}
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

EventMessagesTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array,
  totals: PropTypes.object,
  emptyLabel: PropTypes.string.isRequired,
  emptyTitle: PropTypes.string,
  emptyIcon: PropTypes.node,
  ctaLabel: PropTypes.string,
  ctaHref: PropTypes.string,
};

export default EventMessagesTable;
